// https://github.com/homebound-team/graphql-service/blob/main/src/utils.ts#L88-L102
export function groupBy<T, Y = T>(
  list: readonly T[],
  fn: (x: T) => string,
  valueFn?: (x: T) => Y,
): Record<string, Y[]> {
  const result: Record<string, Y[]> = {};
  list.forEach((o) => {
    const group = fn(o);
    if (result[group] === undefined) {
      result[group] = [];
    }
    result[group].push(valueFn === undefined ? (o as any as Y) : valueFn(o));
  });
  return result;
}

/**
 * Maps the values of an object to a new object.
 * https://github.com/homebound-team/graphql-service/blob/main/src/utils.ts#L117-L119
 * */
export function mapValues<T, U>(record: Record<string, T>, fn: (t: T) => U): Record<string, U> {
  return Object.fromEntries(Object.entries(record).map(([key, value]) => [key, fn(value)]));
}

/** Turns a user-friendly label in an id appropriate for HTML inputs/labels. */
export function makeId(label: string): string {
  return label.replace(" ", "").toLowerCase().replace(/\W/g, "");
}

export function sortText(a: string, b: string) {
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

// Examples: pluralize(tacoCount, "taco"); pluralize(boxCount, "box", "boxes");
// Automatic "s" is for convenience in simple cases; when in doubt, supply the full plural noun
export function pluralize(count: number | unknown[], noun: string, pluralNoun?: string): string {
  if ((Array.isArray(count) ? count.length : count) === 1) return noun;
  return pluralNoun || `${noun}s`;
}
